import { useCallback } from 'react';

import { useCommunityAccess } from '../../_hooks/useCommunityAccess';
import { useCommunityMembership } from '../../_hooks/useCommunityMembership';
import { useCommunityUpgradeReturn } from '../../_hooks/useCommunityUpgradeReturn';
import { useUpgradeHandoff } from '../../_hooks/useUpgradeHandoff';

export interface UpgradeJoinHandoff {
  isAwaitingAccess: boolean;
  markAwaitingAccess: () => void;
  onAccessGranted: () => void;
}

// Reopening `community_join` after the revalidation lands on the join form, because the
// layout routes that intent by `joinGate`.
export const useUpgradeJoinHandoff = (): UpgradeJoinHandoff => {
  const { isCommunityAccessible } = useCommunityAccess();
  const { openJoinModal } = useCommunityMembership();
  const { resumesInviteAcceptance } = useCommunityUpgradeReturn();

  const isGranted = useCallback(() => isCommunityAccessible, [isCommunityAccessible]);
  const onGranted = useCallback(() => {
    if (!resumesInviteAcceptance) openJoinModal();
  }, [openJoinModal, resumesInviteAcceptance]);

  const { awaiting, markAwaitingAccess, onAccessGranted } = useUpgradeHandoff<true>({
    modalType: 'community_join',
    isGranted,
    onGranted,
  });

  return {
    isAwaitingAccess: awaiting === true,
    markAwaitingAccess: useCallback(() => markAwaitingAccess(true), [markAwaitingAccess]),
    onAccessGranted,
  };
};
